import _ from "underscore";
import Backbone from "backbone";
import { Debug } from "../application/Debug";

function _fetchRecursive(promise, page, maxPages) {
    this.fetch({
        complete: () => {
            page ++;
            Debug.log("Mixin._fetchRecursive():", "Completed fetching a page:", page);
            if (this.paging.next && page < maxPages) {
                var [route, params] = this.paging.next.split("?");

                _.each(params.split("&"), (fragment) => {
                    var [name, value] = fragment.split("=");

                    this.filters[name] = value;
                });

                setTimeout(() => {
                    _fetchRecursive.apply(this, [promise, page, maxPages]);
                }, 50);
            }
            else {
                if (this.paging.next) {
                    Debug.log("Mixin._fetchRecursive():", "Reached maximum fetch depth:", maxPages);
                }
                else {
                    Debug.log("Mixin._fetchRecursive():", "Reached the end of the collection");
                }
                promise.resolve();
            }
        },
        remove: false
    });

    return promise;
}

export const fetchRecursive = function(maxPages) {
    Debug.log("Mixin.fetchRecursive():", "Fetching recursively...");

    this.filters["limit"] = 100;
    delete this.filters["skip"];

    var promise = Backbone.$.Deferred();

    return _fetchRecursive.apply(this, [promise, 0, maxPages]);
};


// WEBPACK FOOTER //
// ./src/js/mixins/FetchRecursive.js